import { VideoActionTypes } from './videoTypes';
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case VideoActionTypes.FETCH_VIDEOS_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as videoReducer };
